import React from "react";
import { func } from "../../../utils";
import { useUserData } from "../../../store/user";
import { useNavigate } from "react-router-dom";
import { getStaticImg } from "../../../utils/function";

const imgPath = `${process.env.REACT_APP_API_HOST}/uploads/registration/`;

const Sidebar = () => {
  const { registrationData } = useUserData();

  const regionName = registrationData?.region_name;
  const eventCategoryId = registrationData?.event_category_id;
  const isDanceCategory = eventCategoryId === 3;
  const imgLogo = isDanceCategory
    ? getStaticImg("illustration/piala-byU-2025.png")
    : `${imgPath}${registrationData?.school_logo}`;
  const navigate = useNavigate();
  return (
    <div className="w-[20vw] bg-white md:flex hidden justify-center mt-16 mr-10 ml-[72px]">
      <div className="rounded-2xl border-solid border-[1px] border-[#DDE2E8] h-max pt-5 pb-4 pr-4 w-[246px]">
        <div className="flex items-center mb-4 justify-center">
          <img
            src={imgLogo}
            alt="Logo"
            className="h-[32px] w-[32px]"
            onClick={() => navigate("/")}
          />
          <h1 className="text-xl font-bold ml-4 mb-0">
            {registrationData?.school_name || "-"}
          </h1>
        </div>
        <nav className="flex flex-col text-[14px] font-semibold pr-2">
          <div className="text-[#00BCF1]  py-2 items-center flex align-middle">
            <div class="w-2 bg-[#00BCF1] rounded-r-full h-[40px] mr-[18px] cursor-pointer" />
            Dashboard
          </div>
          {/* <div
            className="ml-[25px] text-[#6A7481] rounded-lg flex items-center mt-3 cursor-pointer"
            onClick={() => navigate(`/${String(regionName)?.toLowerCase()}`)}
          >
            Piala by.U {regionName}
          </div> */}
          <div
            className="flex ml-[25px] text-[#6A7481] rounded-lgitems-center mt-3 cursor-pointer"
            //     className="flex ml-[25px] text-[#6A7481] rounded-lgitems-center mt-[23px] cursor-pointer"
            onClick={() => window.open("https://wa.me/6285182773460", "_blank")}
          >
            Kontak Tim Piala by.U{" "}
            <img
              className="ml-auto"
              src={func.getStaticImg("/illustration/sa-new-tab.svg")}
              alt="new-tab"
            />
          </div>
          <div
            className="ml-[25px] text-[#6A7481] rounded-lg flex items-center mt-[23px] cursor-pointer"
            onClick={() => {
              localStorage.clear();
              window.location.reload();
              window.location.href = "/";
            }}
          >
            Logout
          </div>
        </nav>
      </div>
    </div>
  );
};

export default Sidebar;
